import { FuseRouteItemType } from '@fuse/utils/FuseUtils';
import authRoles from '@auth/authRoles';
import PaymentCallbackPage from './PaymentCallbackPage';

const PaymentCallbackRoute: FuseRouteItemType = {
	path: 'payment-callback',
	element: <PaymentCallbackPage />,
	settings: {
		layout: {
			config: {
				navbar: {
					display: false
				},
				toolbar: {
					display: false
				},
				footer: {
					display: false
				},
				leftSidePanel: {
					display: false
				},
				rightSidePanel: {
					display: false
				}
			}
		}
	},
	auth: authRoles.onlyGuest
};

export default PaymentCallbackRoute;
